export enum ReceiptStatusValues {
  SUBMITTED = 'Submitted',
  PENDING = 'Pending',
  DRAFT = 'Draft',
  INCOMPLETE = 'Incomplete',
  AWAITING_SETTLEMENT = 'AwaitingSettlement',
  SETTLED = 'Settled',
}

export enum ReceiptState {
  Submitted = 'Submitted',
  Pending = 'Pending',
  Draft = 'Draft',
  Incomplete = 'Incomplete',
  AwaitingSettlement = 'AwaitingSettlement',
  Settled = 'Settled',
}

/**
 * Receipts in the settlement flow are neither paid nor pending payment - they
 * are settled manually outside of the regular payment process.
 */
export const isSettlementReceiptState = (
  state?: ReceiptState | null
): state is ReceiptState.AwaitingSettlement | ReceiptState.Settled =>
  state === ReceiptState.AwaitingSettlement || state === ReceiptState.Settled;

/**
 * Draft and Incomplete receipts are not paid automatically - the institution
 * has to submit them manually before any payment is attempted.
 */
export const requiresManualSubmissionReceiptState = (
  state?: ReceiptState | null
): state is ReceiptState.Draft | ReceiptState.Incomplete =>
  state === ReceiptState.Draft || state === ReceiptState.Incomplete;

export const receiptStatusValuesFromString = (
  data: string
): ReceiptStatusValues => {
  // TODO: We can add validation here. But if we throw validation errors, we might break the current application
  return data as ReceiptStatusValues;
};
